import { DirectionalHint } from "@fluentui/react";
import React, { FunctionComponent } from "react";
import { CoachmarkInfo } from "../CoachmarkInfo";
import { PFCoachmark } from "../PFCoachmark";
import { useTranslation } from "../../Locales/i18n/localizationService";
import { CoachmarkLocaleItem } from "../../Locales/Coachmarks/Locale_CoachmarkItem";

export const WorkPackagesCoachmarks: FunctionComponent<any> = React.memo(props => {
	const { t } = useTranslation();
	const createWorkPackageText = new CoachmarkLocaleItem(t("Coachmarks.WorkPackages.CreateWorkPackage.Headline"), t("Coachmarks.WorkPackages.CreateWorkPackage.Text"));
	const pickWorkPackageText = new CoachmarkLocaleItem(t("Coachmarks.WorkPackages.PickWorkPackage.Headline"), t("Coachmarks.WorkPackages.PickWorkPackage.Text"));
	const includeWorkPackageText = new CoachmarkLocaleItem(t("Coachmarks.WorkPackages.IncludeWorkPackage.Headline"), t("Coachmarks.WorkPackages.IncludeWorkPackage.Text"));
	const _createWorkPackage = new CoachmarkInfo("work-packages-create", ".workpackages-icons button", createWorkPackageText, DirectionalHint.rightCenter);
	const _pickWorkPackage = new CoachmarkInfo("work-packages-picker", ".workpackages-selector", pickWorkPackageText, DirectionalHint.rightCenter);
	const _includeWorkPackage = new CoachmarkInfo("work-packages-include", ".tp-workpackages-importcontainer", includeWorkPackageText, DirectionalHint.leftBottomEdge);
	
	return	<>
				<PFCoachmark CoachmarkInfo={_createWorkPackage} />
				<PFCoachmark CoachmarkInfo={_pickWorkPackage} />
				<PFCoachmark CoachmarkInfo={_includeWorkPackage} />
			</>
})

export const WorkPackagesTotalCoachmark: FunctionComponent<any> = React.memo(props => {
	const { t } = useTranslation();
	const totalRowMenuText = new CoachmarkLocaleItem(t("Coachmarks.WorkPackages.TotalWorkMenu.Headline"), t("Coachmarks.WorkPackages.TotalWorkMenu.Text"));
	const _totalRowMenu = new CoachmarkInfo("work-packages-total-row-menu", ".tp-table-header-total", totalRowMenuText, DirectionalHint.rightCenter);
	
	return	<>
				<PFCoachmark CoachmarkInfo={_totalRowMenu} />
			</>
})

export const WorkPackagesTimelineCoachmark: FunctionComponent<any> = React.memo(props => {
	const { t } = useTranslation();
	const workPackageTimelineText = new CoachmarkLocaleItem(t("Coachmarks.WorkPackages.WorkPackageTimeline.Headline"), t("Coachmarks.WorkPackages.WorkPackageTimeline.Text"));
	const _workPackageTimeline = new CoachmarkInfo("work-packages-timeline-period", ".tp-workpackages-timeline tbody tr td:nth-child(20)", workPackageTimelineText, DirectionalHint.bottomCenter);
	
	return	<>
				<PFCoachmark CoachmarkInfo={_workPackageTimeline} />
			</>
})